<template>
  <div
    data-testid="financial-close-settings-side-nav"
    class="fc-settings-side-nav"
  >
    <div
      data-testid="financial-close-settings-side-nav__header"
      class="fc-side-nav__header"
    >
      <span class="fc-side-nav__header-title">Setup Menu</span>
    </div>

    <div
      data-testid="financial-close-settings-side-nav__items"
      class="fc-side-nav__items"
    >
      <router-link
        v-for="(item, index) in settingsItems"
        :key="item.href || item.name || index"
        :data-testid="`financial-close-settings-side-nav__item--${index}`"
        class="fc-side-nav__item"
        :class="{ 'fc-side-nav__item--active': isActive(item) }"
        :to="linkFor(item)"
        @click.native="onNavigate(item)"
      >
        <img
          v-if="iconFor(item)"
          :src="iconFor(item)"
          alt=""
          class="fc-side-nav__icon"
        />
        <v-icon v-else small class="fc-side-nav__mdi">mdi-circle-outline</v-icon>
        <span class="fc-side-nav__label">{{ displayName(item) }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import {
  FC_MENU_NAMES,
  FC_NAV_ICONS,
  FC_SETTINGS_ICON_BY_NAME,
  getSettingsNavDisplayName
} from '@/modules/financialclose/utils/constants';

export default {
  name: 'FinancialCloseSettingsSideNav',
  props: {
    mini: { type: Boolean, default: false },
    selectedItem: { type: String, default: null }
  },
  emits: ['update:selectedItem', 'toggle-mini'],
  data() {
    return {
      FC_NAV_ICONS
    };
  },
  computed: {
    settingsItems() {
      const masters = (this.$store.state.m_financialclose?.menu || [])
        .find((m) => m.name === FC_MENU_NAMES.MASTERS);
      return masters?.items || [];
    }
  },
  methods: {
    displayName(item) {
      if (item?.edit === true) {
        return this.$store.state.LocationHeader || item.name;
      }
      return getSettingsNavDisplayName(item?.name) || '';
    },
    iconFor(item) {
      if (item?.icon) return item.icon;
      return FC_SETTINGS_ICON_BY_NAME[item?.name] || null;
    },
    linkFor(item) {
      if (!item?.href) return {};
      return this.$nova.gotoLink({ path: item.href }, true);
    },
    isActive(item) {
      if (!item) return false;
      const href = (item.href || '').replace(/\/$/, '');
      const path = (this.$route.path || '').replace(/\/$/, '');
      return !!(href && (path === href || path.startsWith(`${href}/`)));
    },
    onNavigate(item) {
      this.$root.closeFloatingComponents?.(item?.name);
      if (item?.name) this.$emit('update:selectedItem', item.name);
    }
  }
};
</script>

<style lang="scss" scoped>
@import './FinancialCloseSideNav.scss';
</style>
